export default __webpack_public_path__ + "static/media/kerpen_dark.52957c0a.png";